import validator from 'validator';
import { axiosInstance } from '../../../config/axiosInstance';
import { globalEnv } from '../../../config/baseConfig';

type ErrorMessageType = { error: boolean; message: string };

export async function checkTopicName({
	originalTopicName = '',
	topicName,
	setTitleErrorMsg
}: {
	originalTopicName?: string;
	topicName: string;
	setTitleErrorMsg: (errorMsg: ErrorMessageType) => void;
}) {
	const { data } = await axiosInstance.get(
		globalEnv.BASE_URL + '/topic/check-topic-name-exists?name=' + topicName
	);
	if (topicName !== originalTopicName) {
		if (data.isUsed === true) {
			setTitleErrorMsg({
				error: true,
				message: 'This name is already used'
			});
		} else {
			setTitleErrorMsg({
				error: false,
				message: ''
			});
		}
	} else {
		if (topicName === '') {
			setTitleErrorMsg({
				error: true,
				message: "Topic name can't be empty"
			});
		} else
			setTitleErrorMsg({
				error: false,
				message: ''
			});
	}
}

export const verifTitle = (
	name = '',
	setTitleErrorMsg: (errorMsg: ErrorMessageType) => void
) => {
	if (validator.isEmpty(name, { ignore_whitespace: true })) {
		setTitleErrorMsg({
			error: true,
			message: 'Please fill out this field.'
		});
	}
};
